import './SliderHandles.39c1ed19112de54cf034efbfa7609ad0.css';
export default {"handles":"_handles_7xeep_1"};